import store from "@/store";
export function requestWithUni(path){
    return path + "?i=" + store.state.vuex_active_uniacid;
}